<template>
  <h1>
    الجلسات المؤجلة
    <i class="fa fa-clock text-success m-1" style="font-size: 18px"></i>
  </h1>
  <div>
    <!-- بطاقات المدرّسين -->
    <div class="row g-5 g-xl-10 mb-5">
      <div v-if="slotsLoading" class="text-center w-100 my-4">
        <div class="spinner-border text-success" role="status">
          <span class="visually-hidden">جاري التحميل...</span>
        </div>
        <div class="mt-2">جاري تحميل الجلسات...</div>
      </div>
      <div v-for="ins in instructors" :key="ins.id" class="col-md-6">
        <div class="card mb-5 mb-xl-8 mt-5 shadow-sm">
          <div class="card-body pb-0">
            <!-- Header -->
            <div class="d-flex align-items-center mb-5">
              <div class="d-flex align-items-center flex-grow-1">
                <!-- Avatar -->
                <div class="symbol symbol-50px me-5">
                  <img
                    :src="imageUrl(ins.instructor_profile.user_img)"
                    :alt="ins.instructor_profile?.user?.fname"
                    @error="onImageError"
                  />
                </div>
                <!-- Info -->
                <div class="d-flex flex-column">
                  <span class="text-gray-900 fs-6 fw-bold text-hover-primary">
                    {{ ins.instructor_profile?.user?.fname }}
                  </span>
                  <small class="text-muted">تصنيف: {{ ins.category_id }}</small>
                </div>
              </div>
              <!-- Rating -->
              <div class="rating my-0">
                <template v-for="(filled, idx) in stars(ins.rating)" :key="idx">
                  <div class="rating-label me-1" :class="{ checked: filled }">
                    <i class="bi bi-star-fill fs-5"></i>
                  </div>
                </template>
              </div>
            </div>

            <!-- العنوان ونوع الجلسة -->
            <div class="mb-3">
              <strong class="text-dark">عنوان الجلسة:</strong>
              <span>{{ ins.title }}</span>
            </div>

            <div class="mb-4">
              <strong class="text-dark">نوع الجلسة:</strong>
              <span>{{ ins.type === "video" ? "فيديو" : ins.type }}</span>
            </div>

            <!-- التاريخ القديم والجديد -->
            <div class="row">
              <!-- الموعد السابق -->
              <div class="col-md-6">
                <div
                  style="
                    border: 1px solid #f1416c;
                    border-radius: 10px;
                    text-align: center;
                    padding: 10px;
                    background: #f1416c0d;
                  "
                >
                  <span class="badge badge-danger">
                    <i class="fa fa-clock text-white m-1"></i>
                    {{ formatTime(ins.old_start_date) }}
                  </span>
                  <br />
                  <span class="badge badge-danger mt-2">
                    <i class="fa fa-calendar text-white m-1"></i>
                    {{ formatDate(ins.old_start_date) }}
                  </span>
                </div>
              </div>

              <!-- الموعد الجديد -->
              <div class="col-md-6">
                <div
                  style="
                    border: 1px solid #50cd89;
                    border-radius: 10px;
                    text-align: center;
                    padding: 10px;
                    background: #50cd890d;
                  "
                >
                  <span class="badge badge-success">
                    <i class="fa fa-clock text-white m-1"></i>
                    {{ formatTime(ins.start_date) }}
                  </span>
                  <br />
                  <span class="badge badge-success mt-2">
                    <i class="fa fa-calendar text-white m-1"></i>
                    {{ formatDate(ins.start_date) }}
                  </span>
                </div>
              </div>

              <!-- الأزرار -->
              <div class="col-md-12 mt-3 text-left">
                <button
                  class="btn btn-danger btn-sm m-2"
                  @click="cancelReservation(ins.id)"
                >
                  <i class="fa fa-close"></i> إسترجاع
                </button>
                <button
                  class="btn btn-success btn-sm m-2"
                  @click="acceptNewDate(ins.id)"
                >
                  <i class="fa fa-check-circle"></i> قبول
                </button>
              </div>
            </div>

            <!-- حالة الجلسة وعدد المقاعد -->
            <div class="mt-4">
              <div><b>عدد المقاعد المتاحة:</b> {{ ins.available_seats }}</div>
              <div><b>نوع الجمهور:</b> {{ ins.audience_type }}</div>
            </div>

            <div class="separator mt-4 mb-2"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- الترحيل بين الصفحات -->
  </div>
</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";

export default {
  name: "PendingSessionsList",
  data() {
    return {
      /* --------- قائم كما هو --------- */
      categoriesData: [],
      selectedCategoryId: null,
      selectedSubCategoryId: null,
      selectedChildCategoryId: null,
      isLoading: true,
      slotsLoading: false,
      isLoggedIn: false,
      token: localStorage.getItem("access_token"),

      /* --------- جديد --------- */
      instructors: [], // البيانات التى سنعرضها

      instructorImgPath: baseUrl + "/images/instructors/", // عدِّل المسار إذا لزم

      /* أي شيء آخر */
      defaultImage: "/assets/img/acad-icon.png",
    };
  },

  computed: {
    /** التخصصات حسب الفئة المختارة */
  },

  mounted() {
    this.getAvailableSlots();
  },

  methods: {
    formatTime(datetime) {
      return new Date(datetime).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    async getAvailableSlots(pageUrl = null) {
      this.slotsLoading = true;

      const endpoint = pageUrl || `${apiUrl}/live-sessions/my-slots`;

      const payload = {
        slots_type: "pending",
      };

      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok) throw new Error(res.status);
        this.slotsLoading = false;
        const json = await res.json();
        /* بيانات الـ API مُهيكلة هكذا: { instructors: { data: [], links:{}, meta:{} } } */
        const wrapper = json.pending_slots;

        this.instructors = wrapper;
      } catch (err) {
        console.error("❌ getAvailableSlots:", err);
      } finally {
        this.slotsLoading = false;
      }
    },

    /* ---------- الإنتقال بين الصفحات ---------- */
    async goToPage(url) {
      if (!url) return;
      // الـ API يقبل استدعاء GET بالرابط الكامل، لذلك نستخدمه كما هو
      await this.getAvailableSlots(url);
    },

    /* ---------- مساعدات صغيرة للعرض ---------- */
    imageUrl(img) {
      return img ? img : this.defaultImage;
    },
    onImageError(event) {
      event.target.src = this.defaultImage;
    },
    /* يحوِّل التاريخ إلى 07/07/2025 12:30 */
    formatDateTime(dt) {
      const d = new Date(dt.replace(" ", "T")); // يدعم Safari
      return (
        d.toLocaleDateString("en-US") +
        " " +
        d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
      );
    },
    /* يحوّل 3.7 إلى مصفوفة طولها 5 لتلوين النجوم */
    stars(rating) {
      const r = Math.round(Number(rating) || 0);
      return Array.from({ length: 5 }, (_, i) => i < r);
    },
    /* هل الجلسة حالياً جارية؟ */
    timeUntilStart(session) {
      const now = new Date();
      const start = new Date(session.start_date);
      const diffMs = start - now;

      if (diffMs <= 0) return "بدأت الجلسة";

      const minutes = Math.floor(diffMs / 60000);
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;

      if (hours > 0) {
        return `ستبدأ الجلسة بعد ${hours} ساعة و ${remainingMinutes} دقيقة`;
      } else {
        return `ستبدأ الجلسة بعد ${remainingMinutes} دقيقة`;
      }
    },

    isLive(session) {
      const now = new Date();
      const start = new Date(session.start_date);
      const end = new Date(session.end_date);
      return now >= start && now <= end;
    },
    formatDate(datetime) {
      return new Date(datetime).toLocaleDateString("en-US", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    timeRange(slot) {
      const s = new Date(slot.start_date);
      const e = new Date(slot.end_date);
      const opts = { hour: "2-digit", minute: "2-digit" };
      return `من ${s.toLocaleTimeString(
        "en-US",
        opts
      )} إلى ${e.toLocaleTimeString("en-US", opts)}`;
    },
    async acceptNewDate(slotId) {
      // أولاً: نطلب تأكيد من المستخدم
      const result = await Swal.fire({
        title: "هل أنت متأكد من قبول موعد الجلسة؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "نعم  ",
        cancelButtonText: "إلغاء",
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        // إذا أكد المستخدم
        Swal.fire({
          title: "جاري الحجز...",
          text: "يرجى الانتظار قليلاً",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        try {
          const endpoint = `${apiUrl}/live-sessions/change-student-slot-state`;
          const payload = { slot_id: slotId, state: "approved" };

          const res = await fetch(endpoint, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });

          if (!res.ok) throw new Error(res.status);

          const json = await res.json();
          if (
            json.status === "error" &&
            json.message === "Already reserved a place in the session!"
          ) {
            // رسالة تحذير
            Swal.fire({
              icon: "warning",
              title: "تنبيه !",
              text: json.message,
            });
          } else {
            // رسالة نجاح
            Swal.fire({
              icon: "success",
              title: "تم حجز الجلسة بنجاح!",
              text: json.message || "تم   الحجز بنجاح.",
            });
          }
        } catch (err) {
          Swal.fire({
            icon: "error",
            title: "حدث خطأ",
            text: "لم يتم الحجز. يرجى المحاولة لاحقًا.",
          });
          console.error("Reservation Error:", err);
        } finally {
          this.slotsLoading = false;
        }
      } else {
        // إذا ألغى المستخدم التأكيد ما نعمل شيء
        console.log("User canceled the reservation");
      }
    },
    async cancelReservation(slotId) {
      // أولاً: نطلب تأكيد من المستخدم
      const result = await Swal.fire({
        title: "هل أنت متأكد من إسترجاع الجلسة؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "نعم  ",
        cancelButtonText: "إلغاء",
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        // إذا أكد المستخدم
        Swal.fire({
          title: "جاري الاسترجاع...",
          text: "يرجى الانتظار قليلاً",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        try {
          const endpoint = `${apiUrl}/live-sessions/change-student-slot-state`;
          const payload = { slot_id: slotId, state: "rejected" };

          const res = await fetch(endpoint, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });

          if (!res.ok) throw new Error(res.status);

          const json = await res.json();
          if (
            json.status === "error" &&
            json.message === "Already reserved a place in the session!"
          ) {
            // رسالة تحذير
            Swal.fire({
              icon: "warning",
              title: "تنبيه !",
              text: json.message,
            });
          } else {
            // رسالة نجاح
            Swal.fire({
              icon: "success",
              title: "تم الاسترجاع بنجاح!",
              text: json.message || "تم   إسترجاع الجلسة.",
            });
          }
        } catch (err) {
          Swal.fire({
            icon: "error",
            title: "حدث خطأ",
            text: "لم يتم الاسترجاع. يرجى المحاولة لاحقًا.",
          });
          console.error("Reservation Error:", err);
        } finally {
          this.slotsLoading = false;
        }
      } else {
        // إذا ألغى المستخدم التأكيد ما نعمل شيء
        console.log("User canceled the reservation");
      }
    },
  },
};
</script>

<style scoped>
.swal2-container.no-flex-swal {
  display: block !important;
  text-align: center;
}

/* المودال نفسه */
.no-flex-swal {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}
</style>
